import { DownloadOutline } from "assets/img/svg/downloadOutline";
import Beneficiaries from "assets/img/svg/navbar/beneficiaries";
import Management from "assets/img/svg/navbar/management";
import Titles from "assets/img/svg/titles";
import type { TImportDataDictionary } from "components/ImportData/type";
import DocumentationLink from "components/shared/DocumentationLink";
import type { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { exportBeneficiaryList } from "store/beneficiaryStore";
import { useAppDispatch } from "store/store";
import { exportTermList } from "store/termStore";
import { exportTitleList } from "store/titleStore";

import { getImportTypeTranslation } from "..";
import StepTitle from "../StepTitle";
import StepWrapper from "../StepWrapper";
import styles from "./style.module.scss";

interface IUploadStep {
    element: TImportDataDictionary | undefined;
    activeStep: number;
    setActiveStep: Dispatch<SetStateAction<number>>;
}

/**
 * Step that show templateFile + link to doc.
 */
const PreparationStep = ({ element, setActiveStep, activeStep }: IUploadStep) => {
    const [t] = useTranslation();
    const dispatch = useAppDispatch();

    const handleDataExport = () => {
        switch (element) {
            case "beneficiars":
                dispatch(exportBeneficiaryList());
                break;
            case "titles":
                dispatch(exportTitleList());
                break;
            case "terms":
                dispatch(exportTermList());
                break;
            default:
                break;
        }
    };

    // TODO once doc written:
    const getLinkToDoc = () => {
        return "";
        // return portalType && (getBasicImportTypeData(dictKey, portalType).relatedDoc as string);
    };

    return (
        <StepWrapper setActiveStep={setActiveStep} activeStep={activeStep} style={{ paddingTop: "100px" }}>
            <div className={styles["preparation-step-container"]}>
                <StepTitle
                    title={t("BulkUpdates.PreparationStep.Title")}
                    subtitle={t("BulkUpdates.PreparationStep.Subtitle", {
                        element: getImportTypeTranslation(element ?? "beneficiars"),
                    })}
                />
                <div className={styles["examples"]}>
                    <DocumentationLink
                        title={t("ImportData.TitleForDoc")}
                        description={t("ImportData.SubtitleForDoc")}
                        link={getLinkToDoc()}
                        style={{ maxWidth: "285px" }}
                    />

                    <ExportDataButton element={element ?? "beneficiars"} handleDataExport={handleDataExport} />
                </div>
            </div>
        </StepWrapper>
    );
};

export default PreparationStep;

const ExportDataButton = ({
    element,
    handleDataExport,
}: {
    element: TImportDataDictionary;
    handleDataExport: () => void;
}) => {
    const [t] = useTranslation();

    const getDetails = {
        beneficiars: { icon: <Beneficiaries />, label: t("ImportData.DownloadBeneficiarsData") },
        titles: { icon: <Titles />, label: t("ImportData.DownloadTitlesData") },
        terms: { icon: <Management />, label: t("ImportData.DownloadTermsData") },
    };

    return (
        <>
            <hr style={{ border: "none" }} />
            <span className={styles["info-span"]}>
                {t("BulkUpdates.PreparationStep.DownloadButton", { element: getImportTypeTranslation(element) })}
            </span>
            <span className={styles["info-span"]}>{t("BulkUpdates.PreparationStep.IDInfo")}</span>
            <div className={styles["download-model"]} onClick={handleDataExport}>
                {getDetails[element].icon ?? <></>}
                <span>{getDetails[element].label ?? ""}</span>
                <DownloadOutline />
            </div>
        </>
    );
};
